/* Legendary USA — Sub-category Pill Persistence v1.3
   v1.3: After restoring the nav, publish --lgd-pills-h (live pill-row height)
   so the sticky filter/sort bar offset stays exact on restored sub-pages too.
   v1.2 FIX: Read lgd_active_category FIRST. This is the family key
   written by the pills section whenever it renders natively on any page.
   By always using that exact pill set on restore, we guarantee Women's
   pills NEVER flip to Gloves/Jackets/any other main-nav category —
   even when URLs appear in multiple categories' href lists. */
(function () {
  'use strict';

  var currentPath = window.location.pathname;

  function findBestPillSet() {
    try {
      /* ── Priority 1: explicit active-category lock ───────────────────
         The section script writes lgd_active_category every time it
         renders, locking in the exact family key the user is browsing.
         Use it directly — no URL-matching needed. */
      var activeKey = sessionStorage.getItem('lgd_active_category');
      if (activeKey) {
        var raw = sessionStorage.getItem(activeKey);
        if (raw) {
          var data = JSON.parse(raw);
          if (data && data.html) return data;
        }
      }

      /* ── Priority 2: fallback URL-match by timestamp ─────────────────
         Fires only on first-ever page load when lgd_active_category
         has never been set (e.g. user bookmarked a sub-page directly). */
      var best = null;
      var bestTime = -1;
      for (var i = 0; i < sessionStorage.length; i++) {
        var key = sessionStorage.key(i);
        if (!key || key.indexOf('lgd_pills__') !== 0) continue;
        var raw2 = sessionStorage.getItem(key);
        if (!raw2) continue;
        var data2 = JSON.parse(raw2);
        if (!data2 || !Array.isArray(data2.hrefs)) continue;
        var match = data2.hrefs.some(function (href) {
          return (href || '').split('?')[0] === currentPath;
        });
        if (match && (data2.savedAt || 0) > bestTime) {
          best = data2;
          bestTime = data2.savedAt || 0;
        }
      }
      return best;
    } catch (e) {}
    return null;
  }

  function restore(data) {
    if (document.querySelector('[data-lgd-pills]')) return;
    var main = document.getElementById('main-content');
    if (!main) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = data.html;
    var nav = tmp.querySelector('[data-lgd-pills]');
    if (!nav) return;

    /* Set active pill: match current URL, fall back to first pill */
    var pills = Array.from(nav.querySelectorAll('.lgd-pill'));
    pills.forEach(function (p) {
      p.classList.remove('is-active');
      p.removeAttribute('data-lgd-active');
    });
    var matched = false;
    pills.forEach(function (p) {
      if ((p.getAttribute('href') || '').split('?')[0] === currentPath) {
        p.classList.add('is-active');
        p.setAttribute('data-lgd-active', 'true');
        matched = true;
      }
    });
    if (!matched && pills.length) {
      pills[0].classList.add('is-active');
      pills[0].setAttribute('data-lgd-active', 'true');
    }

    main.insertBefore(nav, main.firstChild);

    /* Publish the live pill-row height so the existing sticky filter/sort bar
       sits directly beneath the pills with no hardcoded offset (v1.3).
       ResizeObserver is event-driven — not a scroll listener, not polling. */
    try {
      var setPillsHeight = function () {
        document.documentElement.style.setProperty('--lgd-pills-h', nav.offsetHeight + 'px');
      };
      setPillsHeight();
      if (window.ResizeObserver) {
        new ResizeObserver(setPillsHeight).observe(nav);
      }
      window.addEventListener('resize', setPillsHeight);
    } catch (e) {}

    /* Re-attach click feedback and auto-scroll to active pill */
    var scroller = nav.querySelector('[data-lgd-pills-scroll]');
    if (scroller) {
      scroller.addEventListener('click', function (e) {
        var pill = e.target.closest('.lgd-pill');
        if (!pill) return;
        Array.from(scroller.querySelectorAll('.lgd-pill')).forEach(function (p) {
          p.classList.remove('is-active');
          p.removeAttribute('data-lgd-active');
        });
        pill.classList.add('is-active');
        pill.setAttribute('data-lgd-active', 'true');
      });
      var active = scroller.querySelector('[data-lgd-active="true"]');
      if (active) {
        var target = active.offsetLeft - scroller.clientWidth / 2 + active.offsetWidth / 2;
        scroller.scrollTo({ left: Math.max(0, target), behavior: 'auto' });
      }
    }
  }

  var data = findBestPillSet();
  if (!data) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { restore(data); });
  } else {
    restore(data);
  }
})();
